var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDangKyQuyen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.583 9.167c2.987 0 5.417 2.43 5.417 5.416C20 17.57 17.57 20 14.583 20c-2.986 0-5.416-2.43-5.416-5.417 0-2.986 2.43-5.416 5.416-5.416zM6.933.025c.1-.033.2-.033.3 0l6.667 2.5c.158.058.267.217.267.392v4.591C10.45 7.725 7.5 10.817 7.5 14.583c0 .934.183 1.825.517 2.642-.5.192-.825.267-.842.267-.033.008-.058.008-.092.008-.033 0-.058 0-.091-.008C6.925 17.475 0 15.875 0 8.275V2.917c0-.175.108-.334.267-.392zm10.282 12.056c-.346-.304-.872-.267-1.176.078l-2.33 2.663-1.037-1.036c-.325-.326-.852-.326-1.178 0-.326.326-.326.852 0 1.178l1.667 1.667c.157.157.368.244.589.244h.028c.23-.007.447-.11.599-.284l2.916-3.334c.304-.346.268-.873-.078-1.176z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDangKyQuyen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_dang_ky_quyen.b295bc81.svg";
export { ForwardRef as ReactComponent };